import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import getIDfromURL from '../getIDfromURL';
import { getOwnerId } from '../getOwnerId';

export default {
  data() {
    return {
      bookedEvents: [],
    };
  },
  async mounted() {
    await this.fetchBookedEvents(this.$route.params.customerId || getOwnerId()).then((res) => {
      this.bookedEvents.push(...res);
    });
    await this.fetchBookedAwards(this.$route.params.customerId || getOwnerId()).then((res) => {
      this.bookedEvents.push(...res);
    });
  },
  computed: {
    ...mapGetters({
      currentEvent: 'events/fetchEvent',

    }),
  },

  methods: {
    ...mapActions({
      fetchBookedEvents: 'events/fetchBookedEvents',
      fetchBookedAwards: 'awards/fetchBookedAwards',
    }),
    eventDays(start, end) {
      let day = moment(start).format('DD');
      if (end && start !== end) {
        day = `${moment(start).format('DD')} - ${moment(end).format('DD')}`;
      }
      return day;
    },
    moment(date) {
      return moment(date);
    },
    eventMonths(start, end) {
      return moment(start).format('MMM') === moment(end).format('MMM');
    },
    isEvent(url) {
      return url.includes('events');
    },
    isAward(url) {
      return url.includes('awards');
    },
    getRoute(url, slug = '') {
      let route;
      const id = getIDfromURL(url);
      if (url.includes('events')) {
        route = { name: 'standardEvent', params: { eventId: id, slug: slug } };
      }
      if (url.includes('awards')) {
        route = { name: 'globalAwardsEvents', params: { awardId: id, slug } };
      }
      return route;
    },

    isMpActive(isActive, activitionDate) {
      return (
        isActive
          ? moment(moment(new Date().toUTCString()).format('YYYY-MM-DD')).isSameOrAfter(
            moment(activitionDate).format('YYYY/MM/DD'),
          )
          : moment(
            moment(new Date().toUTCString()).add(21, 'days').format('YYYY-MM-DD'),
          ).isSameOrAfter(moment(activitionDate).format('YYYY/MM/DD'))
      );
    },
    isMPEnabled(event) {
      return this.isEvent(event.url)
        && event.meeting_planner_is_active
        && this.isMpActive(event.meeting_planner_is_active, event.meeting_planner_activation_date)
        && event.display_participants
        && this.isAvailable(event.participant_customers);
    },
  },
};
